import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">The Catholic Church in Chicago</p>
        <h1>Catholic Chicago</h1>
        <p className="lede">
          The Archdiocese of Chicago serves roughly 1.9 million Catholics across Cook and Lake Counties -- about a third of the local population -- through 216 parishes led by Cardinal Blase J. Cupich.
        </p>
        <div className="cta-row">
          <a href="#parishes">
            Parish Life
          </a>
          <a href="#leadership" className="secondary">
            Leadership
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>A Major American Archdiocese</h2>
          <p>
            The Archdiocese of Chicago serves about 1,947,000 Catholics -- roughly 33% of Cook and Lake Counties -- across 1,411 square miles, one of the largest Catholic populations in the United States.
          </p>
        </article>
        <article>
          <h2>A Church in Transition</h2>
          <p>
            As of January 2026 the Archdiocese counts 216 parishes, down from 344 after 39 city and 24 suburban church closures -- a significant consolidation reshaping parish life across the region.
          </p>
        </article>
        <article>
          <h2>A Multilingual Church</h2>
          <p>
            The Archdiocese schedules 1,166 weekend Masses -- 768 in English, 261 in Spanish, 87 in Polish, and 50 in other languages -- alongside 143 archdiocese-run elementary schools.
          </p>
        </article>
      </section>

      <section className="section" id="structure">
        <h2>Archdiocesan Leadership</h2>
        <p className="section-sub">The Archdiocese of Chicago is led by Cardinal Blase J. Cupich, seated at Holy Name Cathedral.</p>
        <div className="directory-list">
          <article className="directory-item">
            <h3>Archdiocese of Chicago</h3>
            <p>Cardinal Blase J. Cupich, Archbishop</p>
          </article>
          <article className="directory-item">
            <h3>Holy Name Cathedral</h3>
            <p>The archdiocesan cathedral, site of major ordinations</p>
          </article>
        </div>
      </section>

      <section className="section" id="news">
        <h2>Latest News</h2>
        <p className="section-sub">Recent, sourced developments -- updated as new stories are verified.</p>
        <div className="news-list">
          <article className="news-item">
            <p className="news-date">January 10, 2026 - January 10, 2027</p>
            <h3>Archdiocese observes Franciscan Jubilee Year</h3>
            <p>The Archdiocese is marking the 800th anniversary of the passing of St. Francis of Assisi with a year-long Franciscan Jubilee.</p>
            <p className="news-source">Source: Archdiocese of Chicago</p>
          </article>
          <article className="news-item">
            <p className="news-date">June 20, 2026</p>
            <h3>Cardinal Cupich ordains three new priests</h3>
            <p>Cardinal Cupich ordained three priests for the Archdiocese at Holy Name Cathedral, livestreamed on the Catholic Chicago YouTube channel.</p>
            <p className="news-source">Source: Archdiocese of Chicago</p>
          </article>
          <article className="news-item">
            <p className="news-date">May 16, 2026</p>
            <h3>Thirteen permanent deacons ordained</h3>
            <p>Cardinal Cupich ordained 13 permanent deacons at Holy Name Cathedral, assigned to parishes across the archdiocese including Bartlett, Barrington, Cicero, and Schaumburg.</p>
            <p className="news-source">Source: Chicago Catholic</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default App;
